import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { isNumber } from 'lodash';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';
import { TurnoverListWidgetItem } from '@main-application/turnovers/config/interfaces/turnover-list-widget-item.interface';
import { EColorPalette } from '@shared/enums/color-palette.enum';
import { ChartConfig, ChartDataItem } from '@shared/interfaces/chart-data-item';
import { MeasureType } from '@shared/interfaces/measure-type';

@Component({
  selector: 'app-turnover-list-widget',
  templateUrl: './turnover-list-widget.component.html',
  styleUrls: ['./turnover-list-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TurnoverListWidgetComponent extends ComponentAbstract {
  _widgetItem: TurnoverListWidgetItem;
  _oppositeValue?: number = null;

  @Input() header: string;
  @Input() oppositeLabel: string;
  @Input() measureType: MeasureType;
  @Input() withChart = true;
  @Input() chartColor: EColorPalette = EColorPalette.cBlack;
  @Input() isLoading = true;
  @Input() collapsed = false;

  @Input() set widgetItem(widgetItem: TurnoverListWidgetItem) {
    this._widgetItem = widgetItem;
    if (isNumber(widgetItem.total) && isNumber(widgetItem.value)) {
      this.chartDataList = [
        {
          value: widgetItem.value,
          backgroundColor: this.chartColor,
          label: this.header,
        },
        {
          value: widgetItem.total - widgetItem.value,
          backgroundColor: EColorPalette.cGray2,
          label: this.oppositeLabel,
        },
      ];
      if (widgetItem.total) {
        this._oppositeValue = 100 - Math.round((widgetItem.value / widgetItem.total) * 100);
      } else {
        this._oppositeValue = null;
      }
    } else {
      this.chartDataList = [];
      this._oppositeValue = null;
    }
    this.cdr.detectChanges();
  }

  chartDataList: ChartDataItem[] = [];
  chartConfig: ChartConfig = {
    showTextTooltip: false,
    showTooltip: true,
    showDataLabel: false,
    cutoutLevel: 70,
  };

  constructor(protected cdr: ChangeDetectorRef) {
    super(cdr);
  }

  abbreviateNumber(num, fixed) {
    if (this.measureType === '$') {
      if (num === null) {
        return null;
      } // terminate early
      if (num === 0) {
        return '0';
      } // terminate early
      fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
      const b = num.toPrecision(2).split('e'), // get power
        k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
        c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3)).toFixed(1 + fixed), // divide by power
        d = c < 0 ? c : Math.abs(c), // enforce -0 is 0
        e = d + ['', 'k', 'm', 'b', 't'][k]; // append power
      return e;
    } else {
      return num;
    }
  }
}
